import React, { Component } from 'react'
import Download from '../SVG/Download';
import Mic from '../SVG/Mic'
import Play from '../SVG/Play';
import { Time } from './SectionBase';
export default class Recorder extends Component {

    DEFAULT_MAX_SECONDS = 120

    state = {
        seconds: 0,
    }

    constructor(props) {
        super(props)
        this.prepareMediaRecorder = this.prepareMediaRecorder.bind(this)
        this.record = this.record.bind(this);
        this.stop = this.stop.bind(this);
        this.startTimer = this.startTimer.bind(this); //TODO move this to the parent probably by using isCountUp (Count up timer)?
        this.stopTimer = this.stopTimer.bind(this);
        this.restartTimer = this.restartTimer.bind(this);

    }
    componentDidMount() {
        this.prepareMediaRecorder();
    }

    prepareMediaRecorder(){
        if (navigator.mediaDevices) {
            console.log("getUserMedia supported.");

            const constraints = { audio: true };
            this.chunks = [];

            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    this.mediaRecorder = new MediaRecorder(stream);


                    this.mediaRecorder.onstop = (e) => {
                        console.log("data available after MediaRecorder.stop() called.");
                        const audioBlobType = this.chunks[0].type || "audio/ogg; codecs=opus";
                        const blob = new Blob(this.chunks, { type: audioBlobType });
                        console.log(blob)
                        const audioObjectURL = window.URL.createObjectURL(blob);
                        this.chunks=[];
                        console.log(audioObjectURL);
                        //this.setState({ audioObjectURL, audioBlobType });
                        this.props.onStop({ audioObjectURL, audioBlobType })
                        
                        console.log("recorder stopped");

                    };

                    this.mediaRecorder.ondataavailable = (e) => {
                        this.chunks.push(e.data);
                        console.log(this.chunks);
                    };
                    this.setState({isMediaRecorderError:false})
                })
                .catch((err) => {
                    console.error(`The following error occurred: ${err}`);
                    this.setState({isMediaRecorderError:true})
                });
        }
    }

    record() {
        if (this.mediaRecorder === undefined){
            return;
        }
        this.startTimer();
        if (this.mediaRecorder.state === 'recording') {
            this.stop();
        }
        this.mediaRecorder.start("1000");
        this.setState({ seconds: 0, isRecording:true })
    }

    render() {
        const {audioObjectURL} = this.props;
        const { seconds, isRecording, isPlaying, isMediaRecorderError } = this.state;


        return (
            <div className='m-auto shadow custom-box-1 p-5' style={{ maxWidth: '500px' }}>
                {isMediaRecorderError && <div className='text-danger'> There is an error while loading recorder in your browser. Please make sure you allowed recording in your browser and click the button below  
                <p>
                    <button className='btn btn-warning' onClick={this.prepareMediaRecorder} >Reload The Media Recorder</button>
                </p>
                </div>}
                {!audioObjectURL && <>    <button className='btn p-0' disabled={isMediaRecorderError} onClick={isRecording?this.stop:this.record}>
                    {isRecording?<Play isStop={true} />: <Mic></Mic>}
                   
                </button>
                    <Time isCenter={true} seconds={seconds}></Time></>
                }
                <audio id="audio-replay" controls="" src={audioObjectURL} onPause={()=>this.setState({isPlaying:false})}></audio>
                {audioObjectURL && <>
                    <a href={audioObjectURL} download="recording"><Download></Download></a>
                    <button className='btn' disabled={isPlaying} onClick={() => {this.setState({isPlaying:true}) ;document.getElementById("audio-replay").play() }}><Play></Play></button>
                </>//TODO: Download as Wav: https://stackoverflow.com/questions/65191193/media-recorder-save-in-wav-format-across-browsers
                }
                {false && JSON.stringify(this.state)}
                
            </div>
        )
    }

    stop() {
        console.log('stop');
        this.stopTimer();
        if (this.mediaRecorder!==undefined && this.mediaRecorder.state !== 'inactive') {
            this.mediaRecorder.stop();
        }
        this.setState({isRecording:false, seconds:0});

    }

    startTimer() {
        this.timerInterval = setInterval(() => {
            const { maxSeconds, secondsLeft } = this.props;
            let { seconds } = this.state;
            if (seconds < (maxSeconds || this.DEFAULT_MAX_SECONDS) && secondsLeft > 0) {
                seconds++;
                this.setState({ seconds });
            } else {
                console.log(seconds);
                this.stop();
            }
        }, 1000);
    }

    stopTimer() {
        if (this.timerInterval !== undefined) {
            clearInterval(this.timerInterval);
        }
    }

    restartTimer() {
        this.stop()
        this.startTimer();
    }

    componentWillUnmount() {
        console.log('componentWillUnmount')
        this.stop();
        this.mediaRecorder.onstop = null;
        this.mediaRecorder.ondataavailable = null;
        this.chunks = null;
    }
}
